import {Component, Vue} from 'vue-property-decorator'
import {getCustomerConversionFollowList} from "@/api/common";
import {formatDate} from "@/utils/timeFilter";
import {delNullProperty} from "@/utils";
import {UserModule} from "@/store/modules/user";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class MarketFollow extends Vue {
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number;
    loading = false
    marketClueName = ''
    marketClueSource = ''
    customerConversionName = ''
    userIdList = []
    createdAt = []
    intentionality = ''
    timer = null

    intentionalityList =  [
        {label:'A',value:'A',interpretation:'（7天内签约）'},
        {label:'B',value:'B',interpretation:'（15天内签约）'},
        {label:'C',value:'C',interpretation:'（30天内签约）'},
        {label:'D',value:'D',interpretation:'（90天内签约）'},
        {label:'E',value:'E',interpretation:'（长期跟进）'},
        {label:'F',value:'F',interpretation:'（流失并调入公海）'},
        {label:'已签约',value:'已签约',interpretation:''},
    ]

    created() {
        // this.$nextTick(() => {
        //     (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
        //         const height = res.target;
        //         const clientHeight = height.clientHeight;
        //         const scrollTop = height.scrollTop;
        //         const scrollHeight = height.scrollHeight;
        //         if (clientHeight + scrollTop >= scrollHeight) {
        //             if (this.tableData.length >= this.total) {
        //
        //                 return
        //             }
        //             this.limit += 20
        //             this.getTableData()
        //         }
        //     }, true);
        // })
        this.id = Number(this.$route.query.id)
        this.getTableData()
    }



    async getTableData() {
        this.loading = true
        const data: any = await getCustomerConversionFollowList(delNullProperty({
            page: this.page,
            limit: this.limit,
            marketClueName: this.marketClueName,
            marketClueSource: this.marketClueSource,
            customerConversionName: this.customerConversionName,
            userIdList: this.userIdList,
            createdAt: this.createdAt ? this.changeTime(this.createdAt as Date[]) : '',
            intentionality: this.intentionality,
        }))

        this.total = data.allNum
        this.tableData = data.customerConversionFollowList
        this.loading = false
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    handleSizeChange(val: number) {
        this.limit = val
        this.getTableData()
    }

    handleCurrentChange(val: number) {
        this.page = val
        this.getTableData()
    }

    changeUserIdList(e) {
        this.userIdList = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = 1
            this.getTableData()
        }, 1000)
    }
}
